export default __webpack_public_path__ + "static/media/site_afdal.3bf70fbe.webp";